// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ApproximateIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ApproximateIcon" ref={forwardedRef} {...props}>
      <path d="M6.419 11.434c1.043-.02 2.201.306 3.925 1.079 1.603.659 2.531.919 3.256.951h.3l.223-.014c1.094-.104 1.935-.75 2.639-1.826l.064-.098.086.079 1.04.925.065.058-.05.072c-1.048 1.558-2.216 2.474-3.988 2.58-1.063.07-2.225-.247-4.131-1.07-1.801-.754-2.68-1.018-3.553-.952H6.29c-.64.018-1.14.183-1.581.492-.444.311-.834.77-1.247 1.384l-.064.095-.086-.076-1.073-.96-.066-.06.05-.072.205-.285c1.025-1.385 2.153-2.228 3.784-2.294z" />
      <path d="M6.274 4.75C7.29 4.73 8.45 5.058 10.206 5.862c1.8.72 2.783.985 3.555.952L13.983 6.8c1.088-.107 1.904-.782 2.642-1.862l.065-.096.085.079 1.102 1.018-.048.07c-1.049 1.559-2.251 2.475-4.023 2.546-.9.062-1.927-.146-3.449-.751L9.675 7.52C7.91 6.767 6.993 6.5 6.118 6.534c-.64.034-1.142.2-1.583.505C4.091 7.346 3.701 7.798 3.29 8.41L3.226 8.503 2.067 7.504 2 7.445l.052-.074.204-.284c1.03-1.387 2.188-2.23 3.818-2.329z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ApproximateIcon = /* @__PURE__ */ Object.assign(
  ApproximateIconComponent,
  { displayName: 'ApproximateIcon' },
);
